import i18next from "i18next";
import Logo from '../Assets/images/logo/connectcaremintgreen.png';
import {Link, useNavigate} from "react-router-dom";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {PrimaryButton} from "../Components/Buttons/PrimaryButton";
import {TextInput} from "../Components/Form/TextInput";
import {PasswordInput} from "../Components/Form/PasswordInput";
import {useEffect} from "react";
import * as React from "react";
import {useBoundStore} from "../Store/store";

export const Login = () => {
    const login = useBoundStore((state) => state.login);

    const schema = yup
        .object({
            email: yup.string().required('E-mail is verplicht'),
            password: yup.string().required('Wachtwoord is verplicht'),
        })
        .required()

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    })
    const navigate = useNavigate();

    const user = useBoundStore((state) => state.user);
    const accessToken = useBoundStore((state) => state.accessToken);

    useEffect(() => {
        if(user?.id && accessToken !== null) {
            if(user?.type === 'freelancer') {
                navigate('/freelancer/shifts');
            }

            if(user?.type === 'customer') {
                navigate('/customer/profile');
            }

            if(user?.type === 'admin') {
                navigate('/admin/registrations');
            }
        }
    }, [user]);

    const onSubmit = (data) => {
        login(data.email, data.password).then(() => {});
    }

    return (
        <>
            <div className={`flex flex-col justify-center h-screen w-full items-center relative panel--login`}>
                <div className="h-full flex flex-col justify-center w-full">
                    <div className={'p-3 text-center h-1/3 flex flex-col justify-end'}>
                        <img src={Logo} alt={'Logo for connect care mint green'} className={'max-h-16 mx-auto'}/>
                    </div>
                    <div className="flex flex-col justify-between items-center h-full transform">
                        <div className={'p-3 w-full max-w-[80%] md:max-w-[50%] mx-auto'}>
                            <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
                                <div className={'mb-4'}>
                                    <TextInput
                                        name={'email'}
                                        register={register}
                                        translationIndex={'E-mail'}
                                        errors={errors}
                                    />
                                </div>
                                <div className={'mb-2'}>
                                    <PasswordInput
                                        name={'password'}
                                        register={register}
                                        translationIndex={'Wachtwoord'}
                                        errors={errors}
                                    />
                                </div>
                                <div className={'mt-4 mb-1'}>
                                    <PrimaryButton type={'submit'}>
                                        Aanmelden
                                    </PrimaryButton>
                                </div>
                                <div className={'text-center mt-3'}>
                                    <Link
                                        className={'text-primary hover:text-opacity-50 font-bold transition-all duration-300'}
                                        to={'forgot-password'}>
                                        Wachtwoord vergeten?
                                    </Link>
                                </div>

                                <div className={'mt-4 text-center'}>
                                    <p className={'text-gray-600'}>Ik wil me registreren</p>
                                    <div className={'flex-row space-x-6'}>
                                        <Link
                                            className={'text-primary hover:text-opacity-50 font-bold transition-all duration-300'}
                                            to={'register/freelancer'}>
                                            als zorgprofessional
                                        </Link>
                                        <Link
                                            className={'text-primary hover:text-opacity-50 font-bold transition-all duration-300'}
                                            to={'register/customer'}>
                                            als klant
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}